import { formatDuration, getUnitDurationFromString } from 'lib/utils/date';

/**
 * Spread onto DurationTicker for total setup elapsed — same as MachineSetup
 * "Total Elapsed Setup" and setup wheel inner labels.
 */
const SETUP_ELAPSED_DURATION_TICKER_PROPS = {
  format: 'd[d] h[h] m[m] ss[s]',
  formatOptions: {
    largest: 2,
    trim: false,
  },
};

/**
 * Format planned setup duration for display — same as MachineSetup
 * "Total Expected Setup" (CounterBlock value).
 *
 * @param {string|null|undefined} expectedSetupDuration - activity set field
 * @returns {string|null} formatted duration, or null if missing / unparsable
 */
function formatExpectedSetupDurationForDisplay(expectedSetupDuration) {
  const expectedSetupDurationMs = getUnitDurationFromString(
    expectedSetupDuration,
    'milliseconds'
  );
  if (!expectedSetupDurationMs || !Number.isFinite(expectedSetupDurationMs)) {
    return null;
  }
  return formatDuration(expectedSetupDurationMs / 1000, 'short', {
    trim: 'both',
  });
}

export {
  SETUP_ELAPSED_DURATION_TICKER_PROPS,
  formatExpectedSetupDurationForDisplay,
};
